import React from 'react'
import ReactDOM from 'react-dom'
import Helmet from 'react-helmet'
import { Provider } from 'react-redux'

import Background from './components/Background'

import './index.css'
import './components/Layout.css'
import './down.css'

import { ControlButton, NewTabLink } from './components/Controls'
import { ErrorIcon } from './components/StatusMessage'
import { ServerStatus } from './components/ServerStatus'
import SentryScope from './SentryScope'
import store from './downSetup'

document.body.style.backgroundImage = `url(${Background()})`

ReactDOM.render((
  <div className='webmango'>
    <div className='App'>
      <div className='Layout'>
        <div className='LayoutMain'>
          <Helmet>
            <title>Service Unavailable – WebMango</title>
          </Helmet>
          <div className='modal page fit Down'>
            <ErrorIcon className='pageIcon' />
            <h1>WebMango Unavailable</h1>
            <p className='mainMessage'>
              Sorry, Raijin appears to be down.
            </p>
            <p className='mainMessage'>
              Please try again later.
            </p>
            <p>
              More Info: <NewTabLink className='' to='https://nci.org.au/our-systems/status/'>Raijin Live Status</NewTabLink>
            </p>
            <Provider store={store}>
              <React.Fragment>
                <SentryScope />
                <ServerStatus />
              </React.Fragment>
            </Provider>
            <div className='buttons'>
              <div />
              <div >
                <ControlButton onClick={() => document.location.reload()}>Reload</ControlButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
), document.querySelector('#root'))



// WEBPACK FOOTER //
// ./src/down.js